import axios from 'axios';
import Qs from 'qs';

export const backend = axios.create({
  baseURL: process.env.VUE_APP_BACKEND_BASE_URL || 'http://localhost:8000/api/v1/',
  paramsSerializer(params) {
    return Qs.stringify(params, { arrayFormat: 'repeat' });
  },
});

// needs to be called with Vue.use(HttpPlugin(key, instance))
export class HttpPlugin {
  constructor(instance, key) {
    this.instance = instance;
    this.key = key;
  }

  install(Vue) {
    if (!this.key || !this.instance) {
      throw Error('key and instance must be passed');
    }
    Vue[this.key] = this.instance;
    Vue.prototype[this.key] = this.instance;
  }
}
